import api from "./api";
import { APIS } from "../endpoints";

/**
 * Get file statistics with pagination and search
 * @param {number} limit - Number of records per page
 * @param {number} page - Current page number
 * @param {string} searchTerm - Optional search term
 * @returns {Promise} - Promise with the API response
 */
export const getFileStats = async (limit = 200, page = 1, searchTerm = "") => {
  try {
    const formData = new FormData();
    formData.append('page', page);
    formData.append('limit', limit);

    if (searchTerm) {
      formData.append('search', searchTerm);
    }

    const params = new URLSearchParams(formData);
    const result = await api.get(`${APIS.BASE_URL}${APIS.fileStats}`, {
      params: params
    });

    if (result) {
      return result?.data;
    } else {
      return { data: { data: [], total: 0 } };
    }
  } catch (error) {
    console.error("Error fetching file stats:", error);
    throw error;
  }
};

/**
 * Delete file by filename
 * @param {string} fileName - Name of the file to delete
 * @returns {Promise} - Promise with the API response
 */
export const deleteFileByFileName = async (fileName) => {
  const encodedFileName = encodeURIComponent(fileName);
  try {
    const result = await api.delete(`${APIS.BASE_URL}${APIS.fileStats}/deleteByFileName/${encodedFileName}`);
    
    if (result) {
      return result.data;
    } else {
      return null;
    }
  } catch (error) {
    console.error("Error deleting file:", error);
    throw error;
  }
}; 